// LERP returns a number between start and end based on the amt
// Often used to smooth animations
// Eg. Given: start = 0, end = 100
// - if amt = 0.1 then lerp will return 10
// - if amt = 0.5 then lerp will return 50
// - if amt = 0.9 then lerp will return 90
const lerp = (start, end, amt) => {
  // TODO: rework this or relax ruleset?
  // eslint-disable-next-line no-mixed-operators
  return (1 - amt) * start + amt * end;
};

export default lerp;
